<script setup>
import LohnrechnerForm from '@/components/LohnrechnerForm.vue'
import TeaserComponent from '@/components/TeaserComponent.vue'
import { onMounted } from 'vue'
import { inject } from 'vue'

import { teaserList } from '@/client'
import { ref } from 'vue'
import { client } from '@/lohnrechner'
import { toUnderscore, useTextStore } from '@/stores/texts'

let setDocTitle = inject('setTitle')
let t = inject('t')

let teaser = ref(null)


const languageStore = useTextStore()

async function fetchTeser() {
  let response = await teaserList({ query: { language: toUnderscore(languageStore.language) }, client: client })

  teaser.value = response.data.results[0]
}

onMounted(() => {
  setDocTitle('lohn-fair')
  fetchTeser()
})

languageStore.$subscribe(fetchTeser)

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
</script>
<template>
  <div class="form">
    <LohnrechnerForm></LohnrechnerForm>
  </div>
  <TeaserComponent :quote="teaser.quote" :text="teaser.text" :image="teaser.photo" @click="scrollToTop()" v-if="teaser">
  </TeaserComponent>
</template>

<style scoped>
p {
  margin-bottom: 1em;
}

.form {
  min-height: calc(100vh - 5em);
  margin-left: calc(-1 * var(--container-padding) / 2);
  margin-right: calc(-1 * var(--container-padding) / 2);
  border-radius: 0 0 14px 14px;
  box-shadow: rgba(0, 0, 0, 0.25) 0 4px 4px 0;
  background: white;
  padding-left: max(calc((100vw - 520px) / 2), calc(var(--container-padding) / 2));
  padding-right: max(calc((100vw - 520px) / 2), calc(var(--container-padding) / 2));
  padding-bottom: 2rem;
  z-index: 1;
  flex: 1 1 auto;
  display: grid;
  grid-template-areas: '.' 'progress' 'form' 'form' 'info';
  grid-template-rows: 12vh auto 1fr 1fr 26vh;
}
</style>
